import React, {useEffect, useState} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {showKeyboard} from '@/actions/modalActions';
import {
  changeDeviceName,
  initDeviceSetting,
  setDisabledSaveAction,
  showValidateChangesModal,
} from '@/businesses/deviceSettingBusiness';
import InputField from '@/components/inputfield/InputField';
import * as APPDATA from '@/constants/pcConstAppData';
import * as APPSTYLE from '@/constants/pcConstAppStyle';
import useIntlFormat from '@/hooks/useIntlFormat';
import {getDeviceSetting} from '@/selectors/deviceInfoSelector';

import BottomMenu from '../../menu/bottommenu/BottomMenu';

import DeviceSettingDateTime from './DeviceSettingDateTime';

import './DeviceSetting.less';

function DeviceSetting() {
  const {formatMessage} = useIntlFormat();
  const dispatch = useDispatch();

  const {organization, deviceName, fontSize, isChanged} = useSelector(getDeviceSetting);

  const [discardBottom, setDiscardBottom] = useState(false);

  const style = {
    constraint: {
      fontSize,
    },
  };

  useEffect(() => {
    dispatch(initDeviceSetting());
  }, [dispatch]);

  // NOTE: handle setting is changed
  useEffect(() => {
    dispatch(setDisabledSaveAction(isChanged));
  }, [dispatch, isChanged]);

  const handleBottomBarConfirmation = (cbNavigation) => {
    const handleDiscardCallback = () => {
      setDiscardBottom(true);
      cbNavigation();
    };

    dispatch(showValidateChangesModal(handleDiscardCallback));
  };

  const handleInputClick = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.DEVICE_NAME:
        dispatch(
          showKeyboard({
            keyboardValue: deviceName,
            keyboardTitle: APPDATA.DEVICE_NAME,
            keyboardPlaceholder: APPDATA.DEVICE_NAME,
            keyboardCallBack: (e) => dispatch(changeDeviceName(e.value)),
            max: 30,
          }),
        );
        break;
      default:
        break;
    }
  };

  return (
    <div
      style={style.constraint}
      className="device-setting"
    >
      <div className="row rowHeight middleAlign">
        <div className={APPSTYLE.COLUMN_FULL}>
          <InputField
            label={formatMessage({id: 'deviceSetting.label.deviceName'})}
            inputValue={deviceName}
            fullWidthInput
            onClick={handleInputClick}
          />
        </div>
      </div>
      <div className="row rowHeight middleAlign">
        <div className={APPSTYLE.COLUMN_FULL}>
          <div className="middleAlign">
            <div className={APPSTYLE.COLUMN_INPUT_NORMAL_UNIT}>
              <div className="row row-margin">
                <span className="spanStyleInputField">{formatMessage({id: 'deviceSetting.label.organization'})}</span>
              </div>
            </div>
            <div className={APPSTYLE.COLUMN_INPUT_FULL_WIDTH_NO_UNIT}>{organization}</div>
          </div>
        </div>
      </div>

      <DeviceSettingDateTime />

      <BottomMenu
        isShowConfirmationDialog={isChanged}
        doConfirmationDialog={handleBottomBarConfirmation}
        discardBottom={discardBottom}
      />
    </div>
  );
}
export default DeviceSetting;
